export default "__VITE_ASSET__CFZ8m0pe__"